// src/services/remoteConfigService.js

import { remoteConfig } from "../firebase";
import { fetchAndActivate, getAll, getValue } from "firebase/remote-config";

// A flag to ensure we only initialize once
let isInitialized = false;

/**
 * Initializes Remote Config with default settings and fetches the latest values.
 */
export const initializeAndFetchConfig = async () => {
  if (isInitialized) {
    return;
  }

  // Set default values for the app to use on first load
  remoteConfig.defaultConfig = defaultRemoteConfig;

  // Set fetch settings (low for development, higher for production)
  remoteConfig.settings.minimumFetchIntervalMillis = 180000; // 30 mins

  try {
    await fetchAndActivate(remoteConfig);
    isInitialized = true;
  } catch (error) {
    console.error("Error fetching remote config:", error);
  }
};

/**
 * A direct getter for a specific key. This will be used by our utils.
 * @param {string} key The key of the parameter to retrieve.
 * @returns {import('firebase/remote-config').RemoteConfigValue}
 */
export const getConfigValue = (key) => {
  // Ensure the config is initialized before trying to get a value
  if (!isInitialized) {
    console.warn(
      "Remote Config not initialized. Returning default or empty value."
    );
  }
  return getValue(remoteConfig, key);
};

const defaultRemoteConfig = {
  wedding_ceremony_date: "2025-10-25T18:30:00",
  rsvp_expired_date: "2025-10-01T00:00:00",
};
